export default "__VITE_ASSET__DKQNEJrC__"